import { WindowObj } from '@utils/windowObj';

export type Search = {
    [key: string]: string | undefined;
};

export const getSearch = (): Search => {
    var searchString = WindowObj.location.search.replace(/^(\?)/, '');
    try {
        searchString = `${searchString}&${WindowObj.parent.location.search.replace(/^(\?)/, '')}`;
    } catch (ex) {}
    if (!searchString) {
        return {};
    }
    const searches = searchString.split('&');
    return Object.assign(
        {},
        ...searches.map(s => {
            const ss = s.split('=');
            return {
                [decodeURIComponent(ss[0])]: decodeURIComponent(ss[1]),
            };
        })
    );
};
